import React from 'react'
import styles from '@/styles/shared/Background.module.css'

const Background = ({ backgroundImage }) => {
  return (
    <div className={`${styles.background}`} style={{ backgroundImage: `url('${backgroundImage}')`}}></div>
  )
}

export default Background